import { View } from "./View";
import {
  IPageAndSearchRequest,
  IQueryStringNavLinks,
  ITableHeader,
  IViewSingleTransfer,
  PagedMeta,
} from "../../../interfaces-and-types";
import {
  useGetPageQueryParams,
  useMerchantApiQueryWithParams,
  useQueryString,
  useReactRouterLink,
} from "../../../hooks";
import { filterConstants } from "../../../constants";

interface ISingleTransfersQueryMeta {
  status: string | null;

  filter: {
    // other filters
    country?: string;
    currency?: string;
    batch_ref?: string;
    // reserved_wallet_ref?: string;

    // bankTransferFilter
    account_number?: string;
    account_name?: string;
    bank_name?: string;
    bank_code?: string;

    // gatewayTransferFilter
    merchant_id_or_code?: string;
    merchant_name?: string;
    gateway_name?: string;
    recipient_gateway_code?: string;
  };
}

interface ISingleTransferNoBatchListProps {
  queryFilters?: {
    country?: string;
    currency?: string;
    batch_ref?: string; // can be used with batch details table if batch_ref is supplied

    bankTransferFilter?: {
      account_number?: string;
      account_name?: string;
      bank_name?: string;
      bank_code?: string;
    };
    gatewayTransferFilter?: {
      merchant_id_or_code?: string;
      merchant_name?: string;
      gateway_name?: string;
      recipient_gateway_code?: string;
    };
  };
}

export interface ISingleTransferNoBatchListViewProps {
  transfersInBatch: IViewSingleTransfer[];
  headers: ITableHeader[];
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  openCreateNewModal: () => void;
  openSingleTransferDetailsReceiptModal: (data: any) => void;

  // extra buttons
  onExport: () => void;

  // retryFailedTransfersInBatch: () => void;
}

export const TRANSFERS_LIST_TABLE_NAME = "trsfs";

export const SingleTransferNoBatchList = (
  props: ISingleTransferNoBatchListProps
) => {
  const query = useQueryString();
  const status = query.get(
    `${TRANSFERS_LIST_TABLE_NAME}.${filterConstants.statusKey}`
  );
  const { page, page_size, search } = useGetPageQueryParams({
    queryStringPrefix: TRANSFERS_LIST_TABLE_NAME,
  });

  const { navigate, navigateToRoutePreserveParams } = useReactRouterLink();

  const headers: ITableHeader[] = [
    {
      key: "description",
      header: "Title",
    },
    {
      key: "reference",
      header: "Ref",
    },
    {
      key: "batch_reference",
      header: "Batch Ref",
    },
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "transfer_fee",
      header: "Fees",
    },
    // {
    //   key: "rate",
    //   header: "Rate",
    // },
    {
      key: "bank_name",
      header: (
        <>
          Bank Name
          {/* <br /> /
          Gateway Name */}
        </>
      ),
    },
    {
      key: "account_number",
      header: (
        <>
          Account No
          {/* <br /> /
          Merchant Code */}
        </>
      ),
    },
    {
      key: "account_name",
      header: (
        <>
          Account Name
          {/* <br /> /
          Merchant Name */}
        </>
      ),
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "session_id",
      header: "Session Id",
    },
    {
      key: "created_at",
      header: "Created On",
    },
    {
      key: "paid_at",
      header: "Paid On",
    },
    {
      key: "viewReceipt",
      header: "",
    },
    // {
    //   key: "more",
    //   header: "",
    // },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "All",
        value: null,
      },
      {
        key: "Successful",
        value: "successful",
      },
      {
        key: "Processing",
        value: "processing",
      },
      {
        key: "Failed",
        value: "failed",
      },
    ],
  };

  const {
    isLoading,
    // isSuccess,
    isError,
    data: pagedSingleTransfersListByRef,
    meta: pagedSingleTransfersMeta,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & ISingleTransfersQueryMeta,
    IViewSingleTransfer[],
    PagedMeta
  >(
    [
      "getSingleTransfersList", // singles
      {
        page: (page && Number(page)) || 1,
        page_size: (page_size && Number(page_size)) || 10,
        search,
        status,
        filter: {
          country: props.queryFilters?.country,
          currency: props.queryFilters?.currency,
          batch_ref: props.queryFilters?.batch_ref,
          ...props.queryFilters?.bankTransferFilter,
          ...props.queryFilters?.gatewayTransferFilter,
        },
      },
    ],
    {
      enabled: true,
    }
    // (urlTemplate) => urlTemplate.replace("batch_ref", batch_ref!)
  );

  // const {
  //   // isSuccess: isSuccessRetryFailedTransfersInBatch,
  //   mutate: requeueFailedInBatchByRef,
  // } = useMerchantApiMutation<null, IViewBatchTransfer>(
  //   "requeueFailedInBatchByRef",
  //   [],
  //   {},
  //   (urlTemplate) => urlTemplate.replace("batch_ref", batch_ref!)
  // ).usePostMutation;

  // const retryFailedTransfersInBatch = () => requeueFailedInBatchByRef(null);

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };

  const openCreateNewModal = () => {
    navigate(`create?${query}`);
  };
  // view single transfer details
  const openSingleTransferDetailsModal = (transfer_ref: any) =>
    navigateToRoutePreserveParams(`${transfer_ref}/receipt`);

  return (
    <View
      transfersInBatch={pagedSingleTransfersListByRef || []}
      headers={headers}
      isLoading={isLoading}
      isError={isError}
      totalCount={pagedSingleTransfersMeta?.page_meta.item_count || 0}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      openCreateNewModal={openCreateNewModal}
      openSingleTransferDetailsReceiptModal={openSingleTransferDetailsModal}
      // retryFailedTransfersInBatch={retryFailedTransfersInBatch}
    />
  );
};
